module.exports = __webpack_public_path__ + "public/images/company-logo.6c3314cd737cd31e0cc34522f64b3b25.webp";